
import { mapActions, mapGetters } from 'vuex';
import { isMobile } from '~/utils/screenSizes';
export default {
  name: 'CustomModal',
  props: {
    maxWidth: {
      type: String,
      default: 'screen-md',
    },
    cardHeight: {
      type: String,
      default: null,
    },
    width: {
      type: String,
      default: 'full',
    },
    background: {
      type: String,
      default: 'neutral-1',
    },
    headerShadow: {
      type: Boolean,
      default: true,
    },
    increasedFooter: {
      type: Boolean,
      default: false,
    },
    showBodyPaddingY: {
      type: Boolean,
      default: true,
    },
    mobileTopOffset: {
      type: Number,
      default: 56,
    },
    showDarkBackground: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('modals', [
      'showPortfolioAssetOperationModalFooter',
      'openModals',
    ]),
    widthClass() {
      const classes = 'max-w-' + this.maxWidth + ' w-' + this.width;
      return this.cardHeight ? classes + ' h-' + this.cardHeight : classes;
    },
    // Using this for conditional rendering because tailwind classes cause unwanted behavior
    isMobileSize() {
      return isMobile();
    },
    backgroundClass() {
      return 'bg-' + this.background;
    },
  },
  created() {
    const body = document.body;
    body.classList.add('overflow-y-hidden');
  },
  beforeDestroy() {
    const body = document.body;
    if (this.openModals.length === 0)
      body.classList.remove('overflow-y-hidden');
  },
  methods: {
    ...mapActions('modals', ['hideTopModal']),
    handleCloseModal() {
      this.$emit('onCloseModal');
      this.hideTopModal();
    },
  },
};
